import type { InteractiveArchetype } from '../../../ui/archetypes/InteractiveArchetype';
import { ComponentType } from '../../../ui/shared/enums/ComponentType';

import { Context } from '../../../ui/shared/enums/Context';
import { Direction } from '../../../ui/shared/enums/Direction';
import { Size } from '../../../ui/shared/enums/Size';
import { VisualStyle } from '../../../ui/shared/enums/VisualStyle';
import { FontWeight } from '../../../ui/shared/enums/FontWeight';

import type { InteractiveInput } from '../../../ui/arche/primitives/Interactives/InputInteractive';

/**
 * Default configuration for interactive components.
 * Archetypes should have all styling properties defined.
 */
export const defaultInteractiveArchetype: Partial<InteractiveArchetype> = {
  ariaLabel: '',
  componentType: ComponentType.Interactive,
  isDisabled: false,
  text: '',
  context: Context.None,
  fontWeight: FontWeight.Normal,
  direction: Direction.None,
  size: Size.Medium,
  isBlock: false,
  visualStyle: VisualStyle.Default,
};

export const defaultInteractiveArchetypeInput: Partial<InteractiveInput> = {
  text: '',
  isDisabled: false,
};

/**
 * Placeholder configuration for interactive components, for use in testing or development
 */
export const placeholderInteractiveArchetype: Partial<InteractiveArchetype> = {
  ariaLabel: 'Some Label',
  componentType: ComponentType.Interactive,
  context: Context.Primary,
  direction: Direction.Right,
  isBlock: false,
  isDisabled: false,
  size: Size.Medium,
  text: 'Some Descriptive Text',
  visualStyle: VisualStyle.Highlighted,
  fontWeight: FontWeight.Bold,
};
